import { AnalyzeTinybirdResourceResponseBodyType } from "@intelligems/ig-types/functions/analytics/analyze-resource-tinybird/analyze-resource-tinybird";
import { ExperienceFe } from "@intelligems/ig-types/fe-only/experiences";
import { FeedbackTarget } from "@src/features/ai/components/usages/RateAi";
import {
  EXPERIMENT_ANALYTICS_SUMMARY_WORKFLOW_ID,
  useAnalyticsSummaryV2,
} from "@src/features/ai/components/usages/useAnalyticsSummaryV2";
import { UseQueryResult } from "@tanstack/react-query";

export { EXPERIMENT_ANALYTICS_SUMMARY_WORKFLOW_ID };

interface UseAnalyticsSummaryProps {
  experience: ExperienceFe;
  dashboardData: UseQueryResult<AnalyzeTinybirdResourceResponseBodyType>[];
}

export interface AnalyticsSummaryResult {
  title: string | undefined;
  summaryText: string | undefined;
  isLoading: boolean;
  timestamp: string | undefined;
  sessionId: string | undefined;
  copyFeedback: boolean;
  hasValidAuth: boolean;
  handleCopyToClipboard: () => void;
  handleRefresh: (() => void) | undefined;
  refreshDisabled: boolean;
  refreshTooltip: string | undefined;
  formatTimestamp: (timestamp: string) => string;
  chatInitialContext: unknown;
  footerFeedbackTarget: FeedbackTarget;
  footerWorkflowId: string | undefined;
  startChatDisabled: boolean;
}

export const useAnalyticsSummary = ({
  experience,
  dashboardData,
}: UseAnalyticsSummaryProps): AnalyticsSummaryResult => {
  const summary = useAnalyticsSummaryV2({ experience, dashboardData });

  return {
    title: summary.testSummaryResponse.data?.title,
    summaryText: summary.testSummaryResponse.data?.summary,
    isLoading:
      !summary.variationOverview?.data || summary.testSummaryResponse.isPending,
    timestamp: summary.testSummaryResponse.data?.timestamp,
    sessionId: summary.summary?.data.session_id,
    copyFeedback: summary.copyFeedback,
    hasValidAuth: summary.hasValidAuth,
    handleCopyToClipboard: summary.handleCopyToClipboard,
    handleRefresh: summary.handleRefresh,
    refreshDisabled: summary.refreshDisabled,
    refreshTooltip: summary.refreshTooltip,
    formatTimestamp: summary.formatTimestamp,
    chatInitialContext: summary.summary,
    footerFeedbackTarget: "ai",
    footerWorkflowId: EXPERIMENT_ANALYTICS_SUMMARY_WORKFLOW_ID,
    startChatDisabled:
      !summary.summary || summary.testSummaryResponse.isPending,
  };
};
